export class BookingDataModel {
    DoctorName: string;
    NativeDoctorName: string;
    NativeDeptName: string;
    DoctorCode: string;
    HOD: string;
    IS_BOOK_ALLOW: string;
    DisplayOrder: number;
    DEPT_CODE: string;
    FromTime: string;
    ToTime: string;
    DAYS: string;
    Qualification: string;
    Designation: string;
    FromDate: string;
    Speciality: string;
    Image_Name: string;
    DeptName: string;
    dayCode: string;
    ImageByte: string;
    Token: string;
    SlotPeriod: number;
    SessionCode: string;
    StartTime: Date;
    EndTime: Date;
    DoctorTime: string;
    color: string;
    VisitNo: string;
    VistiDate: string;
    CLINIC_CODE: string;
    SLOT: string;
    DoctorType: string;
    Remarks: string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/booking/bookingdatamodel.ts